/**
 * Listing Marques Manager - Moon Moon Agency
 *
 * Filtre client-side de la liste des marques :
 * - Normalise query + vendor en ASCII lowercase (accent-insensitive)
 * - Hide les items qui ne matchent pas via [hidden]
 * - Hide les groupes lettre dont plus aucun item visible
 * - Affiche le message "aucun resultat" si rien ne matche
 * - Le compteur "X marques" reste fixe sur le total (par choix produit)
 */

const ListingMarquesManager = {
	config: {
		selectors: {
			root: '.mm-listing-marques',
			input: '[data-listing-marques-input]',
			list: '[data-listing-marques-list]',
			group: '[data-listing-marques-group]',
			item: '[data-listing-marques-item]',
			empty: '[data-listing-marques-empty]',
		},
		debounceMs: 80,
	},

	state: {
		root: null,
		input: null,
		groups: [],
		items: [],
		empty: null,
		debounceTimer: null,
	},

	init() {
		const root = document.querySelector(this.config.selectors.root);
		if (!root) return;
		const input = root.querySelector(this.config.selectors.input);
		if (!input) return;

		this.state.root = root;
		this.state.input = input;
		this.state.groups = Array.from(root.querySelectorAll(this.config.selectors.group));
		this.state.items = Array.from(root.querySelectorAll(this.config.selectors.item));
		this.state.empty = root.querySelector(this.config.selectors.empty);

		this._bindEvents();
		window.log('info', '🔠 [LISTING_MARQUES]', 'Initialized', { vendors: this.state.items.length });
	},

	_bindEvents() {
		this.state.input.addEventListener('input', () => {
			clearTimeout(this.state.debounceTimer);
			this.state.debounceTimer = setTimeout(() => this._filter(), this.config.debounceMs);
		});

		this.state.input.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.state.input.value = '';
				this._filter();
			}
		});
	},

	_filter() {
		const raw = this.state.input.value.trim();
		const query = this._normalize(raw);

		let totalVisible = 0;

		this.state.items.forEach(item => {
			const key = item.dataset.vendor || '';
			const match = !query || key.includes(query);
			item.hidden = !match;
			if (match) totalVisible++;
		});

		this.state.groups.forEach(group => {
			const anyVisible = group.querySelector(`${this.config.selectors.item}:not([hidden])`);
			group.hidden = !anyVisible;
		});

		if (this.state.empty) {
			this.state.empty.hidden = totalVisible !== 0;
		}
	},

	/**
	 * Normalise une string pour matching accent-insensitive et case-insensitive.
	 * "Éléonore-T" -> "eleonore-t"
	 */
	_normalize(str) {
		return str
			.normalize('NFD')
			.replace(/[̀-ͯ]/g, '')
			.toLowerCase();
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ListingMarquesManager.init());
} else {
	ListingMarquesManager.init();
}

window.ListingMarquesManager = ListingMarquesManager;
